import { SwaggerTypeBuilder } from "./SwaggerTypeBuilder";
import { ObjectSchema } from "./schema/type/ObjectSchema";

export class SwaggerClassBuilder 
{
    private schema: ObjectSchema;
    constructor(schema: ObjectSchema)
    {
        this.schema = schema;
    }
    runSynch(): string[]
    {
        let lines: string[] = [];
        lines.push(`/**`);
        lines.push(` * @swagger`);
        lines.push(` * components:`);
        lines.push(` *   schemas:`);
        lines.push(` *     ${this.schema.name}:`);
        let line = ` *       `;
        let builder = new SwaggerTypeBuilder(this.schema, false, lines, line);
        builder.runSynch(() => { });
        lines.push(` */`);
        return lines;
    }
}